import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Authorize from '../../components/AuthComponent/Authorize';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import Form from '../../components/Fields/Form';
import TextboxField from '../../components/Fields/TextboxField';
import { FormConfig } from '../../components/Fields/Types';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import { HorizontalTabs } from '../../components/Tabs/HorizontalTabs';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import UserDefinedFieldCategoryModel from '../../models/UserDefinedFieldCategoryModel';
import DataService from '../../services/data.service';
import IdParams from '../../types/IdParams';
import { Result } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';
import UserDefinedFieldCategory_tab_UserDefinedFields from './Tabs/UserDefinedFieldCategory_tab_UserDefinedFields';

const UserDefinedFieldCategoryView: React.FC = () => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: []});
    const { handleResult, handleException } = useNotifications();
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);
    const navigate = useNavigate()
    const [formData, setFormData] = useState<UserDefinedFieldCategoryModel>();

    let idParams: IdParams = useParams();
    let userDefinedFieldCategoryId: number | undefined;
    if (idParams.id && !Number.isNaN(parseInt(idParams.id))) {
        userDefinedFieldCategoryId = parseInt(idParams.id);
    }

    useEffect(() => {
        if (userDefinedFieldCategoryId === undefined) {
            setFormData({
                id: 0,
                name: '',
                concurrencyId: ''
            })
        }
        else {
            DataService.getById<UserDefinedFieldCategoryModel>('api/v1/userdefinedfieldcategories/', userDefinedFieldCategoryId)
                .then(response => setFormData(response))
                .catch(e => {
                    if (e.response?.data?.status === 401)
                        setIsAuthorized(false);
                    else
                        handleException(e);
                });
        }
    }, [userDefinedFieldCategoryId]);

    function submit() {
        if (formData) {
            if (formData.id === 0)
                DataService
                    .create<number>(`api/v1/userdefinedfieldcategories/`, formData)
                    .then(response => {
                        handleResult(response);
                        setServerErrors(response);
                        if (response.isSuccesful === true && response.data)
                            navigate('/plm/itemsetup/userdefinedfieldcategory/' + response.data)
                    })
                    .catch(e => handleException(e));
            else
                DataService
                    .update<UserDefinedFieldCategoryModel>(`api/v1/userdefinedfieldcategories/`, formData)
                    .then(response => {
                        handleResult(response);
                        setServerErrors(response);
                        if (response.isSuccesful === true && response.data)
                            setFormData(response.data);
                    })
                    .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    const { isAuthorizedFor } = useAuth();
    if (userDefinedFieldCategoryId === undefined) {
        if (!isAuthorizedFor(ApplicationFunctions.EditUdfCategory)) {
            return (<Unauthorized />);
        }
    }
    else if (!isAuthorized) {
        return (<Unauthorized />);
    }

    return (
        <div className='main-content'>
            <Form title='User-defined field category' footer={(
                <Row>
                    <Col md='12'>
                        <ButtonBar offset={2}>
                            <Authorize applicationFunction={ApplicationFunctions.EditUdfCategory}>
                                <SaveButton  {...getSubmitButtonProps()} />
                            </Authorize>
                        </ButtonBar>
                    </Col>
                </Row>
            )}>
                <Container fluid>
                    <Row>
                        <Col md='12'>
                            <TextboxField {...getFieldProps('name')} />
                        </Col>
                    </Row>
                </Container>
            </Form>
            {userDefinedFieldCategoryId && (
                <Container fluid>
                    <Row>
                        <Col md='12'>
                            <HorizontalTabs
                                id='vtabs'
                                defaultActiveKey='userDefinedFields'
                                tabs={[
                                    {
                                        title: 'User-defined fields',
                                        eventKey: 'userDefinedFields',
                                        component: <UserDefinedFieldCategory_tab_UserDefinedFields id={userDefinedFieldCategoryId} />,
                                    },
                                ]}
                            />
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    );
}
export default UserDefinedFieldCategoryView;